var render, staticRenderFns
import script from "./Grid.vue?vue&type=script&lang=js&"
export * from "./Grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c590a",
  null
  
)

export default component.exports